import React from 'react'

export default function Pagination({ page, totalPages, onPageChange, disabled }) {
  return (
    <div className="flex justify-end gap-2 border-t px-3 py-2">
      <button
        disabled={disabled || page <= 1}
        className="h-8 rounded border px-3 text-sm hover:bg-gray-50"
        onClick={() => onPageChange(page - 1)}
      >
        Prev
      </button>
      <button
        disabled={disabled || page >= totalPages}
        className="h-8 rounded border px-3 text-sm hover:bg-gray-50"
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </div>
  )
}
